<template>
  <div>
    <label :for="inputId">
      <span>{{ label }}</span>
      <span v-if="isRequired" class="is-required">*</span>
    </label>
    <input
      :type="type || 'text'"
      :id="inputId"
      :placeholder="customPlaceholder"
      :maxlength="maxLength"
      :inputmode="digitsOnly ? 'numeric' : null"
      v-model="inputValue"
      @blur="onBlur"
    />
    <div v-if="errorMsg" class="custom-error-wrapper">
      <span class="custom-error-msg">
        {{ errorMsg }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "label",
    "customPlaceholder",
    "isRequired",
    "customId",
    "errorMsg",
    "startValue",
    "type",
    "prePickedValue",
    "maxLength",
    // digitsOnly - pole telefonu: przyjmuje wylacznie cyfry, obciete do maxLength.
    // Standaryzuje numery do 9 cyfr (SAPP00018), zeby SMS/eksport mialy jeden format.
    "digitsOnly",
  ],
  emits: ["onType", "onBlur"],
  data() {
    return {
      inputId: this.customId,
      inputValue: this.sanitizeDigits(this.prePickedValue),
    };
  },
  mounted() {
    if (this.startValue) {
      this.inputValue = this.sanitizeDigits(this.startValue);
    }
    // On edit the prefilled value is normalized in data() but the watcher does not fire for
    // the initial assignment, so push the cleaned digits up so the parent validates the
    // normalized number (e.g. a legacy "+48 123 456 789" saved as "123456789").
    if (this.digitsOnly && this.inputValue) {
      this.$emit("onType", this.inputValue);
    }
  },
  watch: {
    inputValue(newValue) {
      const clean = this.sanitizeDigits(newValue);
      if (clean !== newValue) {
        // Reassign to drop the rejected character; the watcher re-runs on the clean value.
        this.inputValue = clean;
        return;
      }
      this.$emit("onType", clean);
    },
    prePickedValue() {
      this.inputValue = this.sanitizeDigits(this.prePickedValue);
    },
  },
  methods: {
    sanitizeDigits(value) {
      if (!this.digitsOnly) {
        return value == null ? "" : value;
      }
      let digits = String(value == null ? "" : value).replace(/\D/g, "");
      if (this.maxLength && digits.length > this.maxLength) {
        // Pre-filled legacy values may carry a country prefix (e.g. 48...) - keep the
        // last maxLength digits so an existing "+48 123 456 789" normalizes to 9 digits.
        digits = digits.slice(-this.maxLength);
      }
      return digits;
    },
    onBlur() {
      this.$emit("onBlur", this.inputValue);
    },
  },
};
</script>

<style scoped>
label,
input {
  display: block;
  width: 100%;
  color: #090741;
  font-size: 14px;
  border: unset;
  padding: 0;
  outline: none;
}
label {
  font-weight: 500;
}
.is-required {
  color: #e2037e;
}
input {
  border-bottom: 1px solid #c1c1cf;
  padding-bottom: 5px;
}
input[type="text"]:focus {
  border-bottom: 1px solid #090741;
}
</style>
